import React from 'react';

import positiveIcon from '../../assets/images/g-rect.svg';
import neutralIcon from '../../assets/images/def-rect.svg';
import negativeIcon from '../../assets/images/r-rect.svg';

import styles from './bias-square.module.css';

const DEFAULT_SIZE = 84; // The size (in pixels) to make the squares by default if no custom size is passed

interface BiasSquareProps {
    bias: number | Array<number>, 
    lastUpdateTS: number,
    size?: number
}

const BiasSquare = (props: BiasSquareProps) => {
    const size = props.size || DEFAULT_SIZE;

    if (props.bias.constructor === Array) {
        const src0 = (props.bias[0] === 1) ? positiveIcon : 
            (props.bias[0] === -1) ? negativeIcon: 
            neutralIcon;
        const src1 = (props.bias[1] === 1) ? positiveIcon : 
            (props.bias[1] === -1) ? negativeIcon: 
            neutralIcon;
        const src2 = (props.bias[2] === 1) ? positiveIcon : 
            (props.bias[2] === -1) ? negativeIcon: 
            neutralIcon;
        return (
            <div className={styles.biasSquare}>
                <img src={src0} className={styles.biasArrayItem} width={size}/>
                <img src={src1} className={styles.biasArrayItem} width={size}/>
                <img src={src2} className={styles.biasArrayItem} width={size}/>
            </div>
        )
    }
    
    const thisSrc = (props.bias === 1) ? positiveIcon : 
        (props.bias === -1) ? negativeIcon: 
        neutralIcon;
    
    let displayDate = ""; 
    let displayTime = "";
    if ( props.lastUpdateTS > 0) {
        const lastUpdateDate = new Date(props.lastUpdateTS*1000);        
    
        displayDate = [lastUpdateDate.getMonth() + 1, lastUpdateDate.getDate(), lastUpdateDate.getFullYear()].join('/');
        
        const hourFormatted = (lastUpdateDate.getHours() === 0 || lastUpdateDate.getHours() === 12 ) ? 12 : lastUpdateDate.getHours() % 12; 
        const minFormatted = lastUpdateDate.getMinutes() < 10 ? '0' + lastUpdateDate.getMinutes().toString() : lastUpdateDate.getMinutes()
        const timeTag = lastUpdateDate.getHours() < 12 ? 'am' : 'pm';
        displayTime = [hourFormatted, minFormatted].join(':') + timeTag;
    }
    

    return (
        <div className={styles.biasSquare}>
            <img src={thisSrc} className={styles.image} height={size*5} width={size*5}/>
            <div className={styles.date}>{displayDate}</div>
            <div className={styles.time}>{displayTime}</div>
        </div>
    )
}

export default BiasSquare;